var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.8855,
    cy: 76.8855,
    r: 46.8855,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.576 61.032V74.76C79.576 76.232 79.488 77.696 79.312 79.152C79.136 80.592 78.904 82.064 78.616 83.568H73.576C73.288 82.064 73.056 80.592 72.88 79.152C72.704 77.696 72.616 76.232 72.616 74.76V61.032H79.576ZM71.8 92.232C71.8 91.656 71.904 91.12 72.112 90.624C72.336 90.128 72.632 89.696 73 89.328C73.384 88.96 73.832 88.672 74.344 88.464C74.856 88.24 75.416 88.128 76.024 88.128C76.616 88.128 77.168 88.24 77.68 88.464C78.192 88.672 78.64 88.96 79.024 89.328C79.408 89.696 79.704 90.128 79.912 90.624C80.136 91.12 80.248 91.656 80.248 92.232C80.248 92.808 80.136 93.352 79.912 93.864C79.704 94.36 79.408 94.792 79.024 95.16C78.64 95.528 78.192 95.816 77.68 96.024C77.168 96.232 76.616 96.336 76.024 96.336C75.416 96.336 74.856 96.232 74.344 96.024C73.832 95.816 73.384 95.528 73 95.16C72.632 94.792 72.336 94.36 72.112 93.864C71.904 93.352 71.8 92.808 71.8 92.232Z",
    fill: "#1098F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 173.771,
    height: 173.771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTasks);
export default __webpack_public_path__ + "static/media/NoTasks.d16c2f50ed59409dfbac04e10b4c2186.svg";
export { ForwardRef as ReactComponent };